import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Nav from "../Common/Nav";
import Footer from "../Common/Footer";
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
function Qualified() {

  const location = useLocation();
  if (location.state?.source !== "getLeadInfo") {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Nav />
      <OuterContainer>
        <Container>
          <Heading>Your interests form has already been processed</Heading>

          <BodyText>
            Your interests form has already been processed and can no longer be edited here. Keep an eye out for a message from our team with next steps.
          </BodyText>

          <BodyText>
            If you need to update your information or believe this is a
            mistake, please contact our team at <a href="mailto:support@hippocratic.com">support@hippocratic.com</a>.
          </BodyText>

          <Actions>
            <PrimaryButton as="a" href="mailto:support@hippocratic.com">
              Contact Support
            </PrimaryButton>
            <PrimaryButton background='#ecf3fb' color="#304961" boxshadow='0px 0px 0px' onClick={() => Navigate("/")}>
              Return to Home
            </PrimaryButton>
          </Actions>
        </Container>
      </OuterContainer>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 75vh;
  padding: 40px 24px;
  box-sizing: border-box;

  color: #304961;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-style: normal;
  font-weight: 300;
  letter-spacing: -0.48px;

  border-radius: 15px;

  background-color: #ecf3fb;
`;

const OuterContainer = styled.div`
  padding: 0px 5vw;
`;

const Heading = styled.h1`
  margin: 0 0 20px;
  max-width: 640px;

  font-size: 34px;
  font-weight: 300;
  line-height: 110%;
  letter-spacing: -0.48px;
`;

const BodyText = styled.p`
  margin: 0 0 14px;
  max-width: 560px;

  font-size: 18px;
  font-weight: 300;
  line-height: 150%;
  letter-spacing: -0.2px;
`;

const Actions = styled.div`
  margin-top: 28px;
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items:center;
`;

const PrimaryButton = styled.button`
display:inline-flex;
  font-family: "Museo Sans Cyrl";

  white-space:nowrap;
  box-shadow:${({ boxshadow }) => boxshadow || "0px 0px 20px #304961"};
background-color: ${({ background }) => background || "#304961"};
border:none;
justify-content:center;
align-items:center;
border-radius:70px;
padding:10%;
  border:  solid 1px  #304961;
    cursor: pointer;
       &.Mobile-Btn {
      display: none;
    }
  color:${({ color }) => color || "#E1E7EB"};
    font-size: 1rem; 
  height:60%;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #a0a0a0;
  }

  &:hover:not(:disabled) {
    text-shadow: 0 0 10px rgba(225, 231, 235, 0.8),
                 0 0 20px rgba(225, 231, 235, 0.6),
                 0 0 30px rgba(225, 231, 235, 0.4);
  }
&:hover {
color:white;
  text-shadow: 0 0 10px rgba(225, 231, 235, 0.8),
               0 0 20px rgba(225, 231, 235, 0.6),
               0 0 30px rgba(225, 231, 235, 0.4);
}
          @media screen and (max-width: 690px) {
    font-size: 1rem; 
  padding:10%;
  width:100%;
  margin:0 0 0 0;
  height:5vh;
       &.Desktop-Btn {
      display: none;
    }
             &.Mobile-Btn {
      display: block;

    }
  }
`;



export default Qualified;